
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Music } from 'lucide-react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';

const COLORS = ['#9b87f5', '#6E59A5', '#D6BCFA', '#403E43', '#1A1F2C'];

interface PlatformDistributionChartProps {
  platformData: any[];
}

const PlatformDistributionChart: React.FC<PlatformDistributionChartProps> = ({ platformData }) => {
  return (
    <Card className="bg-card/95 border-border/50">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2 text-white/95">
          <Music className="h-5 w-5 text-soundcharts-purple" />
          Platform Distribution
        </CardTitle>
        <CardDescription className="text-white/70">
          Where your music is being streamed
        </CardDescription>
      </CardHeader>
      <CardContent className="flex items-center justify-center">
        <div className="h-[250px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={platformData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                nameKey="name"
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {platformData.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={COLORS[index % COLORS.length]} 
                  />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(0,0,0,0.8)', 
                  borderColor: 'rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  color: 'rgba(255,255,255,0.9)'
                }} 
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlatformDistributionChart;
